import { isDevlopment } from "src/utils/util";
import { useMemo } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import Button from "src/components/Button/Button";
import { FormField } from "src/components/Form/FormField";
import { FORM_UI_STRINGS, LAYOUT_UI_STRINGS } from "src/data";
import { useLoginMutation } from "src/features/auth/store/auth.api-slice";
import { ILogin } from "src/features/auth/types/props.types";
import { IFormField } from "src/types/form.types";
export const LoginForm = () => {
    const [login] = useLoginMutation();
    const navigate = useNavigate()
    const {
        control,
        handleSubmit,
        reset,
        formState: { errors,isSubmitting },
    } = useForm<ILogin>({
        defaultValues: {
            email: isDevlopment ? "test@taaly.com" : "",
            password: isDevlopment ? "123456" : "",
        },
    });

    const submitHandler: SubmitHandler<ILogin> = async (data) => {
        const userResponse = await login(data);
        if ("data" in userResponse) {
            if (!userResponse.data) {
                toast.error(FORM_UI_STRINGS["wrong-credential"])
            }
            else {
                reset()
                toast.success(FORM_UI_STRINGS["login-success"])
                // Role is inferred server-side from user.roles; redirect accordingly
                // Both admin and employee redirect to /statistics after login
                // Cookies are set synchronously, so we can navigate immediately
                navigate("/statistics", { replace: true });
            }
        } else {
            const message = (userResponse.error as any)?.data?.message as string | undefined;
            if (message === "INVALID_CREDENTIALS") {
                toast.error(FORM_UI_STRINGS["wrong-credential"])
            } else if (message === "NOT_AUTHORIZED") {
                toast.error("Not authorized. Your account must have ADMIN or EMPLOYEE role.")
            } else if (message === "PROFILE_NOT_FOUND") {
                toast.error("User profile not found. Please contact support.")
            } else {
                toast.error(LAYOUT_UI_STRINGS["went-wrong"])
            }
        }
    };

    const loginFields: IFormField[] = useMemo(
        () => [
            {
                label: "email",
                name: "email",
                type: "email",
                placeholder: "Example@mail.com",
                autoFocus: true,
            },
            {
                label: "password",
                name: "password",
                placeholder: "*******",
                type: "password",
            },
        ],
        [],
    );

    return (
        <>
            <form onSubmit={handleSubmit(submitHandler)}>
                {loginFields.map((field: IFormField) => (
                    <div key={field.name} className="mb-3">
                        <FormField {...field} control={control} errors={errors} />
                    </div>
                ))}
                <Button
                    loading={isSubmitting}
                    // className={`submit-btn flex-center mx-auto `}
                    type="submit"
                    disabled={isSubmitting}
                >
                    {LAYOUT_UI_STRINGS.login}
                </Button>
            </form>
        </>
    );
};
